import { render, staticRenderFns } from "./NewDeduction.vue?vue&type=template&id=6d5d7b24"
import script from "./NewDeduction.vue?vue&type=script&lang=js"
export * from "./NewDeduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports